// These *must* be kept in sync with Screenshot::FetchStatus in models/screenshot.rb
enum ScreenshotFetchStatus {
  Done = 0,
  Queued = 1,
  Progress = 2,
  Failed = 3,
}

export default ScreenshotFetchStatus
